module.exports = __webpack_public_path__ + "media/images/loader-11669283fe1de2994354bcb80a5e65d4.gif";